import Super from 'client-portal/routes/-request/prescreener-reason-for-care';

export default class SiteRequestPrescreenerReasonForCare extends Super {}
